import React, { useState } from 'react';
import PropTypes from 'prop-types';

import Button from '../Button/Button';
import { ReactComponent as IconArrowDown } from '../../assets/icon/ic_arrow_down.svg';
import ButtonTypes from '../../constants/buttonTypes';

const ButtonDropdownList = ({
  actionList, item, side, label, Icon, iconStyle, btnContainerStyle
}) => {
  const [openMenu, setOpenMenu] = useState(false);

  return (
    <div
      className="relative w-max"
      onMouseLeave={() => setOpenMenu(false)}
    >
      <Button
        text={label}
        iconRight={<Icon className={`w-[14px] h-[14px] ${iconStyle || ''}`} />}
        type={ButtonTypes.LIGHT}
        containerStyle={`text-[12px] ${btnContainerStyle || ''}`}
        onClick={() => setOpenMenu(!openMenu)}
      />
      {
        openMenu && (
          <div
            className={`shadowDefault animate__animated animate__fadeIn animate__faster
            bg-white dark:bg-background-dark py-[13px] rounded-[5px] absolute w-max min-w-full z-[1]
            ${side === 'left' ? 'right-0' : ''}
            ${side === 'right' ? 'left-0' : ''}
            ${side === 'top' ? 'bottom-[20px]' : ''}`}
          >
            {actionList.map(({
              title, onClick, id, danger
            } = {}) => (
              <div className="py-[2px] px-[9px] flex text-left" key={id}>
                <div
                  role="presentation"
                  className={`w-full text-[12px] capitalize py-[8px] px-[9px] rounded-[5px]
                  ${danger
                    ? 'text-danger hover:text-danger hover:bg-danger-light'
                    : 'hover:text-primary hover:bg-primary-light'}
                  hover:cursor-pointer`}
                  onClick={() => onClick(item)}
                >
                  {title}
                </div>
              </div>
            ))}
          </div>
        )
      }
    </div>
  );
};

ButtonDropdownList.propTypes = {
  actionList: PropTypes.arrayOf(PropTypes.shape({
    id: PropTypes.number.isRequired,
    title: PropTypes.string.isRequired,
    onClick: PropTypes.func,
    danger: PropTypes.bool
  })).isRequired,
  item: PropTypes.shape({ _id: PropTypes.string }),
  side: PropTypes.oneOf(['left', 'right', 'top']),
  label: PropTypes.string,
  Icon: PropTypes.shape({}),
  iconStyle: PropTypes.string,
  btnContainerStyle: PropTypes.string,
};

ButtonDropdownList.defaultProps = {
  item: undefined,
  side: 'left',
  label: '',
  Icon: IconArrowDown,
  iconStyle: undefined,
  btnContainerStyle: undefined,
};

export default ButtonDropdownList;
